import { render, staticRenderFns } from "./ArrearsListTab.vue?vue&type=template&id=4faada69"
import script from "./ArrearsListTab.vue?vue&type=script&lang=js"
export * from "./ArrearsListTab.vue?vue&type=script&lang=js"
import style0 from "./ArrearsListTab.vue?vue&type=style&index=0&id=4faada69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports